/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IRequestContext } from '../../interfaces';
import { isAuthoringEditEnabled } from '../helper';

const EDITABLE_FIELD_CLASS = 'ms-editable-field';

export const getEditableFieldClassName = (disabled?: boolean, className?: string, requestContext?: IRequestContext) => {
    if (!!disabled) {
        return isAuthoringEditEnabled(requestContext) ? `${EDITABLE_FIELD_CLASS} ${className || ''}` : className;
    } else {
        return isAuthoringEditEnabled(requestContext) ? `${EDITABLE_FIELD_CLASS} enabled ${className || ''}` : className;
    }
};

export const isEditorialMode = (requestContext?: IRequestContext) => {
    if (!requestContext) {
        return false;
    }
    return !!requestContext.params && requestContext.params.isEditor;
};

export const isDefaultPlaceholderFeatureOn = (requestContext?: IRequestContext) => {
    if (!requestContext) {
        return false;
    }
    return requestContext.features && requestContext.features.enableDefaultPlaceholder;
};
